<div [ngClass]="{ 'with-sidebar': shouldHaveSidebar, 'no-sidebar': !shouldHaveSidebar }">
    <div class="analytics-heading">Promotion Analytics</div>
    <div class="flex justify-content-end mt-2 mb-3">
        <div class="flex align-items-center justify-content-center m-2">
            <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" [showIcon]="true"
                [showButtonBar]="true" [iconDisplay]="'input'" placeholder="Select dates"
                (onSelect)="onDateRangeChange()" />
        </div>
    </div>

    <!-- Top Cards -->
    <div class="analytics-card-grid">
        <div class="analytics-card">
            <p class="count">{{ views.total }}</p>
            <span class="card-header">Views</span>
            <p class="text--gray-500 text-sm">Unique Views: {{ views.unique }}</p>
        </div>

        <div class="analytics-card">
            <p class="count">{{ clicks.total }}</p>
            <span class="card-header">Clicked GoTo SP</span>
            <p class="text--gray-500 text-sm">Unique Views: {{ clicks.unique }}</p>
        </div>

        <div class="analytics-card">
            <p class="count">{{ conversations.total }}</p>
            <span class="card-header">Started a conversation</span>
            <p class="text--gray-500 text-sm">Unique Customers: {{ conversations.unique }}</p>
        </div>
    </div>

    <!-- Charts Row -->
    <div class="chart-section">
        <div class="chart-card">
            <h4>Date-wise Visits</h4>
            <canvas baseChart [datasets]="dateChartData" [labels]="dateChartLabels" [options]="chartOptions"
                [type]="'bar'">
            </canvas>
        </div>

        <div class="chart-card">
            <h4>Vehicle Brands</h4>
            <canvas baseChart [datasets]="brandChartData" [labels]="brandChartLabels" [options]="chartOptions"
                [type]="'bar'">
            </canvas>
        </div>
    </div>

</div>